<template>
    <div style="min-height: 100vh;background: #F9F9FF;overflow-x: hidden;width: 100%">
        <CommonHeader />
        <img class="grey-bg" src="../../img/grey-bg.png">
        <div class="container" style="min-height: calc(100vh - 231px - 88px + 120px);margin-top: -120px">
            <a-card>
                <a-icon class="t1-icon" type="mail" theme="twoTone"/>
                <p class="t1-text">系统公告</p>
                <a-row>
                    <a-col :span="24">
                        <a-list item-layout="horizontal" :data-source="messageList" :pagination="pagination" >
                            <a-list-item slot="renderItem" slot-scope="item, index">
                                <a-list-item-meta
                                        :description="item.content">
                                    <a slot="title" href="javascript:;">{{ item.title }}</a>
                                    <a-avatar slot="avatar">
                                                                                <a-icon class="icon sound" type="sound" />
                                    </a-avatar>
                                </a-list-item-meta>
                                <span slot="actions">
<!--                                    <B  v-if="item.read === false"  >-->
<!--                                        <a href="javascript:;" style="color: red;font-size: 10px;" @click="onRead(item,index)">标为已读</a>-->
<!--                                    </B>-->
<!--                                    <B v-else style="color: gray;font-size: 10px;">已读</B>-->
                                    &nbsp;&nbsp;
                                    {{item.createdAt}}
                                </span>
                            </a-list-item>
                        </a-list>
                    </a-col>
                </a-row>
            </a-card>


        </div>
        <CommonFooter/>
    </div>
</template>

<script>
  import { mapActions, mapGetters } from 'vuex'
  import qs from 'qs'
  import CommonHeader from '../common/CommonHeader'
  import CommonFooter from '../common/CommonFooter'

  const data = [
    {
      title: 'Ant Design Title 1',
    },
    {
      title: 'Ant Design Title 2',
    },
    {
      title: 'Ant Design Title 3',
    },
    {
      title: 'Ant Design Title 4',
    },
  ]
  export default {
    name: 'SysMessage',
    components: {
      CommonHeader,
      CommonFooter,
    },
    created () {
        this.initData()
    },
    data () {
      return {
        data,
        userName: '',
        stopDate: '',
        orgName: '',
        id: this.$route.query.id,
          msgInfoVisible: false,
          messageList: [],
          current: 1,
          pagination: {
              onChange: page => {
                  console.log(page);
              },
              itemRender:(current, type, originalElement) => {
                  if (type === 'prev') {
                      return <a>上一页</a>;
                  } else if (type === 'next') {
                      return <a>下一页</a>;
                  }
                  return originalElement;
              },
              showTotal:(total) => {
                  return `共${total}条`
              },
              showSizeChanger:true,
              defaultPageSize:10
          },
      }
    },
    methods: {
        initData() {
            this.messageList = []
            let that = this
            this.$http.get('/api/1/supplier/sysMessage/getSysMessageList.json').then(function (res) {
                that.messageList = res.result
                that.readAll()
            })
        },
        onRead(item,index) {
            if (item.read) {
                return
            }
            let that = this
            this.$http.get('/api/1/supplier/sysMessage/read.json?userNotifyId='+item.userNotifyId).then(function (res) {
                if (res.code === 200) {
                    item.read = true
                    that.$set(this.messageList,index,item)
                }
            });
        },
        readAll() {
            this.$http.get('/api/1/supplier/sysMessage/read_all.json').then(function (res) {
                if (res.code == 200 ) {
                    console.log(res.msg)
                }
            })
        }
    }
  }
</script>

<style scoped>
    .handle {
        background: none;
    }

    .handle .right a {
        margin-left: 30px;
    }

    .grey-bg {
        position: relative;
        left: 50%;
        margin-left: -960px;
    }

    .t1-icon {
        position: absolute;
        top: -38px;
        font-size: 40px;
        left: 0;
        right: 0;
        width: 80px;
        height: 80px;
        line-height: 80px;
        background: #fff;
        border-radius: 40px;
        margin: auto;
    }

    .t1-text {
        text-align: center;
        position: relative;
        z-index: 99;
        font-size: 18px;
    }

    /deep/ .ant-avatar {
        border-radius: 0;
        background: none;
    }

    /deep/ .ant-avatar-string {
        transform: scale(1) translateX(-50%) !important;
    }

    .icon {
        width: 32px;
        height: 32px;
        line-height: 34px;
        vertical-align: top;
        border-radius: 4px;
    }

    .sound {
        background: #e6f7ff;
        color: #1890ff;
        border: 1px solid #91d5ff;
    }

    .user {
        background: #f6ffed;
        color: #52c41a;
        border: 1px solid #b7eb8f;
    }
</style>
